import * as React from "react";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Alert from "components/bootstrap/Alert";
import { Description } from "report/common/Description";
const ParametersWarning = styled(Alert)`
  margin-bottom: 30px;
`;
const ParametersTable = styled.div`
  font-size: 0.75em;
  min-width: 50%;
  margin: 0 auto 30px auto;

  td,
  th {
    border: 1px #ccc solid;
    padding: 5px;
  }
`;
const getParameterValue = (parameterValues, name, defaultValue) => isNil(parameterValues[name]) ? defaultValue : parameterValues[name];
const ReportParameters = ({ parameters, parameterValues }) => {
  const { t } = useTranslation("enterprise_report");
  if (isEmpty(parameters)) {
    return null;
  }
  const formattedParameters = Object.entries(parameters).map(([name, { default_value: defaultValue }]) => {
    const value = getParameterValue(parameterValues, name, defaultValue);
    return /* @__PURE__ */ React.createElement("tr", { key: name }, /* @__PURE__ */ React.createElement("td", null, "$", name, "$"), /* @__PURE__ */ React.createElement("td", null, value || /* @__PURE__ */ React.createElement("em", null, t("report_render_parameters.not_set"))));
  });
  const parametersWithMissingValue = Object.values(parameters).filter((p) => !p.optional && p.needsBinding).filter(({ name, default_value: defaultValue }) => !getParameterValue(parameterValues, name, defaultValue)).map(({ name }) => name);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, parametersWithMissingValue.length > 0 && /* @__PURE__ */ React.createElement(ParametersWarning, { bsStyle: "danger", title: t("report_render_parameters.missing_value_title") }, /* @__PURE__ */ React.createElement("p", null, t("report_render_parameters.missing_value_text")), /* @__PURE__ */ React.createElement("b", null, parametersWithMissingValue.join(", "))), /* @__PURE__ */ React.createElement(Description, null, t("report_render_parameters.uses_parameters")), /* @__PURE__ */ React.createElement(ParametersTable, null, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, t("report_render_parameters.parameter")), /* @__PURE__ */ React.createElement("th", null, t("report_render_parameters.value")))), /* @__PURE__ */ React.createElement("tbody", null, formattedParameters)));
};
export default ReportParameters;
